import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PythonSetting } from "../typeDefs/pythonSettings";

export interface PythonSettingsState {
	settings: PythonSetting[];
	settingsLoading: boolean;
}

const initialState: PythonSettingsState = {
	settings: [],
	settingsLoading: false,
};

export const pythonSettingsSlice = createSlice({
	name: "pythonSettings",
	initialState,
	reducers: {
		setPythonSettings: (state, action: PayloadAction<PythonSetting[]>) => {
			state.settings = action.payload;
		},
		setPythonSettingsLoading: (state, action: PayloadAction<boolean>) => {
			state.settingsLoading = action.payload;
		},
	},
});

export const { setPythonSettings, setPythonSettingsLoading } =
	pythonSettingsSlice.actions;

export default pythonSettingsSlice.reducer;
